import { IS_BROWSER, IS_PROD } from "@smartrr/shared/constants";
import { applyMiddleware, createStore } from "redux";
import thunk, { ThunkMiddleware } from "redux-thunk";

import { CustomerAction, CustomerActionActionType, CustomerStore } from "@customer-app/state/typedCustomerRedux";

import { IPortalState, initialState, rootReducer } from "../reducers";

function getCreateStore() {
  const castedThunkMiddleware = thunk as ThunkMiddleware<IPortalState, CustomerAction<CustomerActionActionType>>;

  const logger = (store: any) => (next: any) => (action: any) => {
    return next(action);
  };

  if (IS_PROD()) {
    return applyMiddleware(castedThunkMiddleware)(createStore);
  }
  return (
    (IS_BROWSER && (window as any)?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    require("@redux-devtools/extension").composeWithDevTools
  )(applyMiddleware(castedThunkMiddleware, logger))(createStore);
}

export const store = (function initStore(): CustomerStore {
  const store = getCreateStore()(rootReducer, initialState);

  // for webpack hot reloading (idk if that's happening)
  if (!IS_PROD() && (module as any)?.hot) {
    // Enable Webpack hot module replacement for reducers
    (module as any)?.hot.accept("../reducers", () => {
      const nextReducer = require("../reducers");
      store.replaceReducer(nextReducer);
    });
  }

  return store;
})();

export { getCreateStore as getCreateStoreForTest };
